<template>
  <span v-if="item.text" class="tag-label" :class="{ 'tag-label--muted': item.muted }">
    <component :is="item.icon" v-if="item.icon" :width="16" :height="16" color="#282930" class="min-w-16" />
    {{ item.text }}
  </span>
</template>

<script lang="ts">
export default {
  name: 'TagLabel',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  word-break: break-word;
  background: theme('colors.grey.background.contrast');
  border: 1px solid theme('colors.grey.graphics.subdued');
  color: theme('colors.grey.body');
  padding: 0.25rem 1rem;
  border-radius: 2rem;
  font-size: 0.875rem;
  font-weight: 500;

  &--muted {
    border: none;
    font-weight: 400;
  }
}
</style>
